import { requestJson } from './requestJson';

export async function postSignOut(): Promise<{ signed_out: boolean }> {
  return await requestJson('/auth/signout', { method: 'POST' });
}
